import { render, staticRenderFns } from "./Left.vue?vue&type=template&id=52b0c2a7&"
import script from "./Left.vue?vue&type=script&lang=ts&"
export * from "./Left.vue?vue&type=script&lang=ts&"
import style0 from "./Left.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports